export default "__VITE_ASSET__vPVbXiYL__"